import fetch from 'isomorphic-fetch';
import AppConfig from '../Configs/App';
import Auth from '../Containers/Authentication/Auth';

const fifteenMinutes = 900000;
class Api {
  cache(key, response, cacheMiliseconds = fifteenMinutes) {
    const cacheDate = new Date();
    const newDate = cacheDate.getTime() + cacheMiliseconds;
    const cache = {
      key,
      createdAt: cacheDate.getTime(),
      expires: newDate,
      value: response,
    };

    sessionStorage.setItem(key, JSON.stringify(cache));
  }

  get(action, params = {}, useCache = false, checkAuthorization = true) {
    if (checkAuthorization && Auth.expired()) {
      Auth.logout();
      return new Promise((resolve, reject) => {
        reject();
      });
    }
    const url = AppConfig.apiUrl() + action;

    const promise = new Promise((resolve, reject) => {
      if (useCache) {
        let cachedHits = sessionStorage.getItem(action);
        if (cachedHits) {
          cachedHits = JSON.parse(cachedHits);
          console.log(cachedHits.expires);
          console.log(new Date().getTime());
          console.log(cachedHits.expires < new Date().getTime());
          if (cachedHits.expires < new Date().getTime()) {
            sessionStorage.removeItem(action);
          } else {
            return resolve(cachedHits.value);
          }
        }
      }

      return fetch(url, params).then((response) => {
        if (response.status >= 402) {
          reject(new Error(response.statusText));
        }

        resolve(response.json());
      }).then(response => response);
    });

    return promise;
  }
}

export default new Api();



// WEBPACK FOOTER //
// ./src/Services/Api.js